module.exports = __webpack_public_path__ + "assets/fonts/45482f9e-3c4c-4dee-836c-53ac7be680ec.1b75155f.eot";